Monitoring.Views ||= {}

class Monitoring.Views.WhatsappAudioControlsManager

  constructor: (@containers) ->

  _initWhatsappAudioControls: ->
    $(@containers).each (index, element) ->
      current_element = $(this)
      aud = current_element.find('audio')
      audio = aud[0]
      play_button = current_element.find('.icon-btn')
      progress_bar = current_element.find('.progressBar')
      progress_back = current_element.find('.progress')
      current_time = current_element.find('.time')
      play_button.click ->
        if (audio.paused)
          audio.play()
          play_button.removeClass('icon-btn-play')
          play_button.addClass('icon-btn-pause')
        else
          audio.pause()
          play_button.removeClass('icon-btn-pause')
          play_button.addClass('icon-btn-play')

      $(audio).bind 'timeupdate', ->
        progress = audio.currentTime / audio.duration * 100

        if(progress == 100)
          play_button.removeClass('icon-btn-pause')
          play_button.addClass('icon-btn-play')

        if (progress > 95)
          progress = 95
        progress_bar.css('width', progress + '%')
        progress_back.css('width', 95 - progress + '%')
        current_time.html(_formatAudioTime(audio.currentTime))


  _formatAudioTime = (time) ->
    time = Math.floor(time)
    minutes = Math.floor(time / 60)
    seconds = time - minutes * 60
    minutes = "0" + minutes
    seconds = "0" + seconds
    minutes.substring(minutes.length-2) + ':' + seconds.substring(seconds.length-2)



